import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import classnames from 'classnames';
import TabeeAuth from '../../../tabee-auth';
import { strings, ui } from '../../../tools';
const SignUpForm = ({
  errorMessage,
  translator,
  i18nPrefix,
  inputClassName,
  onResult
}) => {
  const t = translator,
    prefix = i18nPrefix ? `${i18nPrefix}.` : '',
    [email, $email] = useState(''),
    [username, $username] = useState(''),
    [locked, $locked] = useState(false),
    [message, $message] = useState(''),
    onRegister = () => {
      if (locked || !email || !username) return;
      $locked(true);
      $message('');
      TabeeAuth.register({
        email,
        username
      }).then(onResult).catch(event => {
        $locked(false);
        console.log(event);
        $message(!event.message ? 'Something goes wrong' : event.message);
        ui.focusFirstInput();
      });
    },
    checkDisabledSubmit = () => locked || !email || !username,
    next = () => [].slice.call(document.querySelectorAll('.tabee-login__input'))[1].focus(),
    makeUsername = () => {
      if (username) {
        return;
      }
      const res = email.replace(/\.com$/, '').replace(/[^0-9a-zA-Z]+/g, '');
      $username(res);
    };
  useEffect(() => {
    $message(errorMessage);
    $locked(false);
  }, [errorMessage]);
  useEffect(() => {
    ui.focusFirstInput();
  }, []);
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Item, null, /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    className: classnames('tabee-login__input', 'tabee_login__input-email', inputClassName),
    placeholder: t(`${prefix}email`),
    disabled: locked,
    value: email,
    onChange: e => $email(e.target.value),
    onBlur: makeUsername,
    onPressEnter: next
  })), /*#__PURE__*/React.createElement(Form.Item, null, /*#__PURE__*/React.createElement(Input, {
    className: classnames('tabee-login__input', 'tabee_login__input-username', inputClassName),
    placeholder: t(`${prefix}username`),
    disabled: locked,
    value: username,
    onChange: e => $username(e.target.value),
    onPressEnter: onRegister
  })), /*#__PURE__*/React.createElement(Form.Item, {
    className: "tabee-login__offset-wrap"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "tabee-login__submit",
    type: "primary",
    disabled: checkDisabledSubmit(),
    onClick: onRegister
  }, t(`${prefix}signUp`))), !!message && /*#__PURE__*/React.createElement("div", {
    className: "tabee-login__message"
  }, t(`errors.${strings.toKey((typeof message === 'string' ? message : 'networkError').split(',')[0])}`)));
};
export default SignUpForm;